export default __webpack_public_path__ + "static/media/stuck-veskovic-modernes-badezimmer-5.1909a8bc.jpg";